<template>
    <div class="qr-detail">
        <h3 class="title">文件验证</h3>
        <div class="container">
            <div class="doc-info">
                <div class="info-item">
                    <span class="label">文件名称：</span>
                    {{ contract.subject }}
                </div>
                <!-- <div class="info-item">
                    <span class="label">签署人：</span>
                    {{ contract.creatorName }}
                </div>
                <div class="info-item">
                    <span class="label">签署时间：</span>
                    {{ contract.updateTime }}
                </div> -->
            </div>

            <div v-for="signatory of signatories" :key="signatory.hash">
                <div
                    v-for="(item, index) of signatory.signatureInfos"
                    :key="index"
                >
                    <div class="doc-info">
                        <div class="info-item">
                            <span class="label">文件有效性：</span>
                            {{
                                signatory.statusCode
                                    ? "文件已被修改"
                                    : "本次签名有效"
                            }}
                        </div>
                        <div class="info-item">
                            <span class="label">签名信息：</span>
                            （文件中共有{{ signatory.signaturesNum }}个签名）
                        </div>
                    </div>
                    <div class="signatories">
                        <div class="info">
                            <div class="info-item">
                                <span class="label">签章结果：</span>
                                <span
                                    :class="
                                        item.code ? 'red-text' : 'green-text'
                                    "
                                >
                                    {{
                                        item.code
                                            ? "经验证，本次签名无效"
                                            : hasCertRootChain(item)
                                            ? "经验证，本次签名有效，签章者身份有效性未知"
                                            : "经验证，本次签名有效"
                                    }}
                                </span>
                            </div>
                            <div class="info-item">
                                <span class="label">签章人：</span>
                                {{ item.signatory }}
                            </div>
                            <div class="info-item">
                                <span class="label">颁发机构：</span>
                                {{ item.organization }}
                            </div>
                            <div
                                class="info-item"
                                v-if="item.cardNo && item.cardNo !== 'null'"
                            >
                                <span class="label">签章人标识：</span>
                                {{ dataMasking(item.cardNo, item.signType) }}
                            </div>
                            <div class="info-item">
                                <span class="label">签章时间： </span>
                                {{ item.signTime }}
                            </div>
                            <div class="info-item" v-if="item.verifyTimestamp">
                                <span class="label">使用时间戳： </span>
                                {{ item.msg }}
                                <span
                                    class="green-text"
                                    v-if="item.verifyTimestamp"
                                    >(该时间为权威时间戳，经验证有效)</span
                                >
                                <span class="red-text" v-else
                                    >(该签名包含时间戳，经验证无效)</span
                                >
                            </div>
                            <div
                                class="info-item"
                                v-if="item.strAlgName !== 'SM3withSM2'"
                            >
                                <span class="label">签名算法： </span>
                                RSA
                            </div>
                            <div
                                class="info-item"
                                v-if="item.strAlgName !== 'SM3withSM2'"
                            >
                                <span class="label">签名状态： </span>
                                {{ !item.code ? "有效" : "已失效" }}
                            </div>
                            <div class="info-item" v-if="item.containSm2">
                                <span class="label">签名算法： </span>
                                SM2
                            </div>
                            <div class="info-item" v-if="item.containSm2">
                                <span class="label">签名状态： </span>
                                {{ item.sm2Verify ? "有效" : "已失效" }}
                            </div>
                        </div>

                        <div class="stamper">
                            <div class="seal-title">电子印章</div>
                            <img :src="item.imgString" class="seal-img" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="doc-content">
                <div class="doc-title">文件内容</div>
                <div v-for="doc of documentList" :key="doc.id" class="doc-img">
                    <img
                        v-for="page of doc.pages"
                        :key="page"
                        v-lazy="{
                            src: `${BASE_APP_PATH}/document/image?zwdt_access_token=${zwdt_access_token}&documentId=${doc.id}&pageNo=${page}`,
                            loading: placeholderImage,
                        }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            contract: {},
            signatories: [],
            documentList: [],
            placeholderImage: require("../../assets/images/common/placeholder.png"),
        };
    },
    computed: {
        zwdt_access_token() {
            return this.$route.query.zwdt_access_token;
        },
    },
    created() {
        this.getContractDetail(this.zwdt_access_token);
    },
    methods: {
        // 存在且结果为false时，经验证，本次签名有效，签章者身份有效性未知
        hasCertRootChain(message) {
            if (message.hasOwnProperty('hasCertRootChain')) {
                return !message.hasCertRootChain;
            }
            return false;
        },
        async getContractDetail(zwdt_access_token) {
            this.axios({
                url: "/zwdt/view/detail",
                method: "GET",
                params: { zwdt_access_token: this.zwdt_access_token },
            }).then((resp) => {
                if (!resp.data.code) {
                    this.contract = resp.data.contract;
                    this.docmentsVerify();
                }
            });
        },
        async getContractVerify(zwdt_access_token, documentId) {
            const resp = await this.axios({
                url: "/verify/by/documentId",
                method: "GET",
                params: { zwdt_access_token, documentId },
            });
            if (resp.data.code === 0) {
                return resp.data;
            }
        },
        docmentsVerify() {
            this.documentList = this.contract.documents || [];
            this.documentList.forEach(async (doc) => {
                const signatory = await this.getContractVerify(
                    this.zwdt_access_token,
                    doc.id
                );
                this.signatories.push(signatory);
            });
        },
        dataMasking(val, type) {
            if (type === "PERSONAL") {
                return (
                    val.slice(0, 6) +
                    "***********" +
                    val.slice(val.length - 1, val.length)
                );
            } else {
                return (
                    val.slice(0, 8) +
                    "***********" +
                    val.slice(val.length - 1, val.length)
                );
            }
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    padding: 20px 10%;
}

.qr-detail {
    .title {
        text-align: center;
        line-height: 58px;
        border-bottom: 1px solid rgba(229, 229, 229, 1);
    }

    .doc-info {
        .info-item {
            line-height: 24px;
            font-size: 16px;
            color: #7f8997;
            margin-bottom: 16px;

            .label {
                color: #001330;
                font-weight: bolder;
            }
        }
    }

    .signatories {
        display: flex;
        border: 1px solid rgba(229, 229, 229, 1);
        margin-bottom: 8px;

        .info {
            flex: 1;
            padding: 24px 0 24px 24px;

            .info-item {
                line-height: 24px;
                font-size: 14px;
                margin-bottom: 16px;
                color: #001330;
                font-weight: bolder;

                .label {
                    color: #7f8997;
                }
            }
        }

        .stamper {
            width: 232px;
            background: #fdf7f6;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;

            .seal-title {
                color: #000000;
                font-size: 14;
                font-weight: bolder;
            }

            .seal-img {
                width: 150px;
                margin-top: 8px;
            }
        }
    }

    .doc-content {
        margin-top: 32px;

        .doc-title {
            margin-bottom: 14px;
            color: #001330;
            font-weight: bolder;
        }

        .doc-img {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                width: 100%;
                box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
                margin-bottom: 20px;
            }
        }
    }
}

@media screen and (max-width: 750px) {
    .container {
        padding: 20px;
    }

    .qr-detail {
        .title {
            text-align: center;
            line-height: 58px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
        }

        .doc-info {
            .info-item {
                line-height: 20px;
                font-size: 12px;
                margin-bottom: 16px;

                .label {
                    font-weight: bold;
                }
            }
        }

        .signatories {
            flex-direction: column;

            .info {
                padding: 24px 24px 0 24px;

                .info-item {
                    line-height: 20px;
                    font-size: 12px;
                    margin-bottom: 10px;
                    font-weight: bold;
                }
            }

            .stamper {
                width: 100%;
                background: none;
                justify-content: flex-start;
                align-items: start;
                padding: 0 24px 24px 24px;

                .seal-title {
                    color: #7f8997;
                    font-size: 12px;
                    font-weight: bold;

                    &::after {
                        content: "：";
                    }
                }

                .seal-img {
                    width: 150px;
                    margin-top: 8px;
                }
            }
        }

        .doc-content {
            margin-top: 32px;

            .doc-title {
                margin-bottom: 14px;
                font-weight: bold;
            }
        }
    }
}
</style>